export default "__VITE_ASSET__Bj2lMQ1I__"